import { render, staticRenderFns } from "./project.vue?vue&type=template&id=be393a7a&"
import script from "./project.vue?vue&type=script&lang=ts&"
export * from "./project.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\references\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be393a7a')) {
      api.createRecord('be393a7a', component.options)
    } else {
      api.reload('be393a7a', component.options)
    }
    module.hot.accept("./project.vue?vue&type=template&id=be393a7a&", function () {
      api.rerender('be393a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/project.vue"
export default component.exports